require('dotenv').config();
import * as mainConfig from './config';

export const databaseUrl = process.env.DATABASE_URL;
export const googleMapServerAPI = process.env.GOOGLE_MAP_SERVER_API;
export const auth = {
    jwt: { secret: process.env.JWT_SECRET },
    ...mainConfig.auth,
}
export const cronTimezone = process.env.CRON_TIMEZONE;